<template>
	<b-modal ref="modal" title="Change your username" :busy="loading>0">
		<b-form @submit.stop.prevent="changeUsername()" id="changePasswordForm">
			<b-form-group label="Current username">
				<b-form-input v-model="currentUsername" placeholder="Current username" required></b-form-input>
			</b-form-group>
			<b-form-group label="New username">
				<b-form-input v-model="username" placeholder="New username" required></b-form-input>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{ ok, cancel }">
			<div class="w-100">
				<div class="float-right">
					<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner>
					<b-button variant="primary" type="submit" form="changePasswordForm" class="mr-2">Change</b-button>
					<b-button size="sm" @click="cancel()">Cancel</b-button>
				</div>
			</div>
		</template>
	</b-modal>
</template>

<script>
export default {
	data: () => ({
		currentUsername: '',
		username: '',
		loading: 0,
		error: null,
	}),
	methods: {
		show() {
			this.$refs.modal.show();
		},
		async changeUsername() {
			try {
				this.loading++;
				this.error = null;
				await this.$api.post('changeUsername', {
					currentUsername: this.currentUsername,
					username: this.username,
				});
				this.$refs.modal.hide();
				this.$bvToast.toast('Successfully changed username.', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	},
}
</script>
